<template>
  <div />
</template>

<script>

/**
 * Vue: Product comparison (product-comparison)
 * -----------------------------------------------------------------------------
 * Carousel of products comparing parameters.
 * - Limited interactivity section.
 *
 * @param {String} liquid.sectionId - Section's Liquid ID.
 *
 */
import Splide from '@splidejs/splide'

export default {
  name: 'ProductComparison',

  props: {
    liquid: {
      type: Object,
      default: () => ({
        sectionId: '',
      }),
    },
  },

  data() {
    return {

    }
  },

  mounted() {
    this.container = document.querySelector(`#vue-element .section-${this.liquid.sectionId}`)
    this.nonbannersplide = this.container.querySelector('.non_banner_splide')
 
   
    this.bannersplide = this.container.querySelector('.banner_splide')
  
    this.createCarousel()
    this.createNonCarousel()
    this.bindEventListeners()
  
    if(this.bannersplide != null){
        if (this.isInView(this.bannersplide)) {
          this.initializeCounterDigits()
        }
      }
    if(this.nonbannersplide != null){
      if (this.isInView(this.nonbannersplide)) {
        this.initializeCounterDigits()
      }
    }
  },

  methods: {
    isInView(container) {
      const windowHeight = window.innerHeight
     
      const elementRectangle = container.getBoundingClientRect()
      const elementTop = elementRectangle.top
      const elementBottom = elementRectangle.bottom

      const topInView = (elementTop > 0) && (elementTop < windowHeight)
      const bottomInView = (elementBottom > 0) && (elementBottom < windowHeight)

      if (topInView || bottomInView) {
        return true
      }

      return false
    },

    bindEventListeners() {
      cnvs.EventBus.listen('cnvs:scroll', () => {
    if(this.bannersplide != null){
        if (this.isInView(this.bannersplide)) {
          this.initializeCounterDigits()
        }
      }
      if(this.nonbannersplide != null){
        if (this.isInView(this.nonbannersplide)) {
          this.initializeCounterDigits()
        }
      }
      })
    },

    initializeCounterDigits() {
      if( this.nonbannersplide != null){
        this.nonbannersplide.classList.add('is-in-view')
      }
      if(this.bannersplide != null){
        this.bannersplide.classList.add('is-in-view')
      }
    
    },

    createCarousel() {
      if(this.bannersplide != null) {
      new Splide(this.bannersplide, {
        gap: 24,
        perPage: 1.5,
        perMove: 1,
        focus: 0,
        omitEnd: true,
        breakpoints: {
          1024: {
            perPage: 1.125,
            perMove: 1,
            gap: 8,
            focus: 0,
            omitEnd: true,
          },
        },
      }).mount()
    }
    },

    createNonCarousel() {
      if(this.nonbannersplide != null) {
        new Splide(this.nonbannersplide, {
          gap: 24,
          perPage: 2,
          perMove: 1,
          focus: 0,
          omitEnd: true,
          breakpoints: {
            1024: {
              perPage: 1.125,
              perMove: 1,
              gap: 8,
              focus: 0,
              omitEnd: true,
            },
        },
      }).mount()
    }

    },



},

}
</script>

<style lang="scss">
@import './product-comparison';
</style>
